import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faTruck, faTrash, faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import Numeral from 'numeral';
import moment from 'moment';
import 'moment/locale/es';

class tarjetas extends React.Component {

    cardTypes = [
        "Ordenes Sin Asignar",
        "Ordenes En Ruta"
    ];

    onClickAsignarOrden = (event) => {
        event.stopPropagation();
        this.props.assignOrder("btnAssignSingleOrder");
    };

    unasignedOrders = (type, claseEstado, claseTipo, claseApoyo, item, onClick, style) => {

        moment.locale("es");
        let lllFormat = moment(item.Tiempo_Transcurrido, "dddd D, MMMM, YYYY, HH:mma");
        let today = moment();
        let days = today.diff(lllFormat, 'days');

        let actualHour = moment(today.format("HH:mm").toString(), "HH");
        let thenHour = moment(lllFormat.format("HH:mm").toString(), "HH");
        let actualMinute = moment(today.format("mm").toString(), "mm");
        let thenMinute = moment(lllFormat.format("mm").toString(), "mm");
        let actualSecond = moment(today.format("ss").toString(), "ss");
        let thenSecond = moment(lllFormat.format("ss").toString(), "ss");
        let hours = actualHour.diff(thenHour, 'hours');
        let minutes = actualMinute.diff(thenMinute, 'minutes');
        let seconds = actualSecond.diff(thenSecond, 'seconds');

        hours = hours < 0 ? hours + 23 : hours;
        minutes = minutes < 0 ? minutes + 60 : minutes;

        if (days < 10) { days = "0" + days }
        if (hours < 10) { hours = "0" + hours }
        if (minutes < 10) { minutes = "0" + minutes }
        if (seconds < 10) { minutes = "0" + seconds }

        let Tiempo_Transcurrido = `${days}:${hours}:${minutes}:${seconds}`;

        return (
            <>
                <div id={`card-${item.Id}`} style={style} className={"orden-button-sm " + claseEstado} onClick={(event) => onClick(event, { handler: type, data: item })}>
                    <div className="orden-identificador" style={{ position: "relative", float: "left" }}>
                        <span className="number">{"#" + item.Id}</span>

                        {type !== this.cardTypes[0] ?
                            <span>{
                                claseTipo === "PU" ?
                                    <FontAwesomeIcon icon={faStore} /> :
                                    <FontAwesomeIcon icon={faTruck} />
                            }</span>
                            :
                            ""
                        }
                        <p>{Tiempo_Transcurrido.toString()}</p>
                    </div>
                    <div className="orden-cliente" style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ width: "100%", margin: "20px 0px 0px 0px", justifyContent: "center", flexFlow: "column" }}>
                            <strong>{item.Fecha_Creacion.toString()}</strong>
                            <div className="row no-gutters">
                                <div className="col">
                                    <span className="ecom-number">{this.props.simboloMoneda} {Numeral(item.Monto.Valor).format('0,0.00')}</span>
                                </div>

                                <div className="col">
                                    <span className="suc-apoy"><i className={claseApoyo}></i></span>
                                </div>
                                {
                                    claseEstado && claseEstado.includes('selected') ?
                                        <div className="col text-right">
                                            <Button className="btn-sm" onClick={this.onClickAsignarOrden} variant="primary" style={{ fontSize: '1em' }}>
                                                <FontAwesomeIcon icon={faMotorcycle} /> ASIGNAR
                                            </Button>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    ordersEnRoute = (item, onClick) => {
        moment.locale("es");
        let Fecha_Creacion = moment(item.Fecha_Creacion, "dddd D, MMMM, YYYY, HH:mma").format("DD/MM/YYYY H:mm a");

        return (
            <div style={{ padding: "1em", height: "100%" }} className={"col-12 orden-button"}>
                <div className="row justify-content-between" style={{ color: "#4C7EF8" }}>
                    <div className="col-3">
                        <strong className="number">{"#" + item.Id}</strong>
                    </div>
                    <div className="col-3" style={{ textAlign: "right" }}>
                        <FontAwesomeIcon onClick={(event) => onClick(event, { handler: "unassignOrder", data: item })} style={{ cursor: "pointer" }} icon={faTrash} />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-12" onClick={(event) => onClick(event, { handler: "showOrderProducts", data: item })} style={{ cursor: "pointer" }}>
                        <div className="row">
                            <div className="col-4"><strong>{Fecha_Creacion.toString()}</strong></div>
                            <div style={{ textAlign: "center" }} className="col-2"><strong>{item.Tipo_Pago.Tipo === "RE" ? "Regal\u00eda" : item.Tipo_Pago.Contado ? "Contado" : "Cr\u00e9dito"}</strong></div>
                            <div style={{ textAlign: "center" }} className="col-2"><strong>{item.Estatus === "R" ? "En Ruta" : item.Estatus === "T" ? "Terminado" : "Facturado"}</strong></div>
                            <div style={{ textAlign: "right" }} className="col-4"><strong>{this.props.simboloMoneda} {Numeral(item.Monto.Valor).format('0,0.00')}</strong></div>
                        </div>
                        <div className="row">
                            <div className="col-12 mt-3">
                                <strong>{item.Direccion_Completa}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { type, claseEstado, claseTipo, claseApoyo, item, onClick, style } = this.props

        switch (type) {
            case this.cardTypes[0]:
                return this.unasignedOrders(type, claseEstado, claseTipo, claseApoyo, item, onClick, style)

            case this.cardTypes[1]:
                return this.ordersEnRoute(item, onClick)
        }
    }
}

const mapStateToProps = state => {
    return {
        simboloMoneda: state.parametros.simboloMoneda
    };
};

export default connect(mapStateToProps)(tarjetas);